import { authorizeGetRequest, authorizePatchRequest } from "api";
import { IApiResponse, IPaginatedResponse } from "models";
import { IFleet, IFleetUpdateInput } from "models/fleet";

export const fleetsApi = (page: number, perPage: number, query: string, category: string = "") => {
  return authorizeGetRequest<IPaginatedResponse<IFleet>>(
    `fleets?page=${page}&per_page=${perPage}&query=${query}${category ? `&category=${category}` : ""}`
  );
};

export const fetchFleetByIdApi = (id: string) => {
  return authorizeGetRequest<IApiResponse<IFleet>>(`fleets/${id}`);
};

export const updateFleetApi = (id: string, data: IFleetUpdateInput) => {
  return authorizePatchRequest<IApiResponse<IFleet>>(`fleets/${id}`, data);
};
